import { flow, makeAutoObservable, observable, when } from "mobx";

import booksRepository from "./Books.repository";

export default class BooksStore {
  allBooks = [];
  privateBooks = [];
  isAdding = false;
  isLoadingAll = false;
  isLoadingPrivate = false;

  constructor() {
    makeAutoObservable(this, {
      allBooks: observable.shallow,
      privateBooks: observable.shallow,
      addBook: flow.bound,
      _loadBooks: flow.bound,
    });
    this.loadAllBooks();
    this.loadPrivateBooks();
  }

  loadAllBooks() {
    return this._loadBooks("allBooks", "isLoadingAll", "getAllBooks");
  }

  loadPrivateBooks() {
    return this._loadBooks(
      "privateBooks",
      "isLoadingPrivate",
      "getPrivateBooks",
    );
  }

  *addBook({ name, author }) {
    if (this.isAdding) {
      return;
    }

    this.isAdding = true;

    try {
      if (yield booksRepository.addBook({ name, author })) {
        yield when(() => !this.isLoadingAll && !this.isLoadingPrivate);
        this.allBooks.push({ name, author });
        this.privateBooks.push({ name, author });
      }
    } finally {
      this.isAdding = false;
    }
  }

  *_loadBooks(targetField, loadingFlag, getterMethod) {
    if (this[loadingFlag]) {
      return;
    }

    this[loadingFlag] = true;

    try {
      this[targetField] = yield booksRepository[getterMethod]();
    } finally {
      this[loadingFlag] = false;
    }
  }
}
